import React, { useEffect, useRef } from 'react'

const AutoScroll = ({
  children,
  shouldScroll = true,
  dependencies, // spread props don't work in dependency array
  scrollMargin,
  scrollSnapAlign,
}) => {
  const childrenRef = useRef(null)
  useEffect(() => {
    if (shouldScroll) {
      childrenRef.current?.scrollIntoView?.({ behavior: 'smooth' })
    }
  }, [dependencies, shouldScroll])

  return React.cloneElement(
    React.isValidElement(children) ? (
      <div style={{ scrollMargin, scrollSnapAlign }} className='max-w-full'>
        {children}
      </div>
    ) : (
      children
    ),
    {
      ref: childrenRef,
    },
  )
}

export default AutoScroll
